import { HEADER_HEIGHT } from '@/constants/app';

export const setCSSVariables = () => {
  const root = document.documentElement;
  root.style.setProperty('--header-height', `${HEADER_HEIGHT}px`);
};
